import {io} from "socket.io-client"
import store from "@/store"

const socket = io(window.location.origin)
    .on('updateStage', async message => {
        await store.dispatch('setStage', message.stage)
    })

export default socket
